import { fetchFidcData } from 'services/api/core/applications/fidc'
import { fetchCreditReference } from 'services/api/core/underwriting/fidc/applications/creditReference'
import { fetchApproveCredit } from 'services/api/core/analysis/auto-refi/data/credit-references/approve-credit'
import { getItem, setItem } from 'services/localStorage/cache'
import { addDays } from 'date-fns'

async function fetchUpsellMargin(
  applicationId: string,
): Promise<{ delta: number }> {
  const cacheKey = `fetchUpsellMargin:${applicationId}`
  const cacheValue = getItem(cacheKey)

  if (cacheValue) {
    return cacheValue
  }

  try {
    const { id: fidcId } = await fetchFidcData(applicationId)
    const { id: creditReferenceId } = await fetchCreditReference(fidcId)
    const { maxLoanAmountApproved, contractLoanAmount } =
      await fetchApproveCredit(creditReferenceId)

    let delta = maxLoanAmountApproved - contractLoanAmount

    if (delta < 0) {
      delta = 0
    }

    setItem(cacheKey, { delta }, addDays(new Date(), 3))
    return { delta }
  } catch (error) {
    return { delta: 0 }
  }
}

export { fetchUpsellMargin }
